(function () {
    'use strict';

    angular.module('app').controller('TerminalsController', TerminalsController);

    TerminalsController.$inject = [
        '$rootScope',
        '$scope',
        '$routeParams',
        '$location',
        '$timeout',
        '$translate',
        '$filter',
        '$route',
        '$uibModal',
        'blockUI',
        'LANGS',
        'NotifyService',
        'TerminalService',
        'POSService',
        'BusinessService',
        'SelectService',
        'PriceGroupsService',
        'FeedbackService',
        'LoyaltyService', 'SettingsService'];

    function TerminalsController(
        $rootScope,
        $scope,
        $routeParams,
        $location,
        $timeout,
        $translate,
        $filter,
        $route,
        $uibModal, blockUI,
        LANGS,
        NotifyService,
        TerminalService,
        POSService,
        BusinessService,
        SelectService,
        PriceGroupsService,
        FeedbackService,
        LoyaltyService,
        SettingsService
    ) {
        var isRoadTankerDriverMode = !!$route.current.$$route.isRoadTankerDriverMode;
        $scope.isRoadTankerDriverMode = isRoadTankerDriverMode;

        $scope.isInCust = appConfig.platformParams.main_site.en === 'incust.com';
        $scope.model = {
            registerFeedback: {},
            possibilityPrintFeedbackOnCheck: false,
            use_price_group: false
        };
        $scope.modals = {};
        $scope.messages = {
            error: null
        };

        $scope.valueOptions = [
            {
                title: 'Default',
                value: 'default'
            },
            {
                title: 'Not use',
                value: 'not-use'
            },
            {
                title: 'Manual',
                value: 'manual'
            }
        ];

        $scope.data = {
            registersFilter: isRoadTankerDriverMode ? {'type': 'road-tanker-driver'} : {},
            pagerLengths: [10, 20, 50, 100, 200],
            paramsAdditionalCostsItems: {
                page: 1,
                count: 20,
                only_active: true,
                item_category_id: 'all'
            },
            priceGroups: [],
            registerTypes: [
                {id: 'register', title: 'TEXT_MODE_REGISTER'},
                {id: 'steward', title: 'TEXT_MODE_STEWARD'},
                {id: 'validator', title: 'TEXT_MODE_VALIDATOR'},
                {id: 'prepaid-services', title: 'TEXT_MODE_PREPAID_SERVICES'},
                {id: 'road-tanker-driver', title: 'TEXT_MODE_ROAD_TANKER_DRIVER'},
                {id: 'kiosk', title: 'TEXT_MODE_KIOSK'},
                {id: 'kiosk-and-register', title: 'TEXT_MODE_KIOSK_AND_REGISTER'}
            ],
            kioskModes: [
                {id: 'customer-identity', title: 'Customer Authentication'},
                {id: 'gift-redeem', title: 'Selection and redeeming of rewards'},
                {id: 'login-pad', title: 'LoginPad'},
                {id: 'steward', title: 'TEXT_STEWARD'}
            ],
            printFeedbackSourceOnCheckTypes: [
                {value: 'qr-code', title: 'qr-code print'},
                {value: 'url', title: 'url print'},
                {value: 'all', title: 'all print'}
            ],
            invitationMessageTypes: [
                {value: 'push-chatbot-sms', title: 'TEXT_PUSH_CHATBOT_VIBER_SMS'},
                {value: 'push-chatbot-viber', title: 'TEXT_PUSH_CHATBOT_VIBER'},
                {value: 'push-chatbot', title: 'TEXT_PUSH_CHATBOT'},
                {value: 'viber-sms', title: 'TEXT_VIBER_SMS'},
                {value: 'push', title: 'TEXT_PUSH'},
                {value: 'chatbot', title: 'TEXT_CHATBOT'},
                // {value: 'viber', title: 'TEXT_VIBER'},
                {value: 'sms', title: 'TEXT_SMS'},
                {value: 'email', title: 'TEXT_EMAIL'},
                {value: 'external-system', title: 'TEXT_EXTERNAL_SYSTEM'}
            ],
            feedbackAllowedTypes: [
                {value: 'none', title: 'none'},
                {value: 'authorized-users-only', title: 'authorized-users-only'},
                {value: 'all-users', title: 'all-users'}
            ],
            screensaverTypes: [
                {value: 'youtube', title: 'ScreensaverType#youtube'},
                // {value: 'image', title: 'ScreensaverType#image'}
            ],
            notify_if_connection_lost_more_then_options: [
                {id: 0, title: 'Do not notify'},
                {id: 5, title: '5 minutes'},
                {id: 10, title: '10 minutes'},
                {id: 20, title: '20 minutes'},
                {id: 30, title: '30 minutes'},
                {id: 45, title: '45 minutes'},
                {id: 60, title: '1 hour'}
            ],
            notify_if_logged_out_more_then_options: [
                {id: 0, title: 'Do not notify'},
                {id: 5, title: '5 minutes'},
                {id: 10, title: '10 minutes'},
                {id: 20, title: '20 minutes'},
                {id: 30, title: '30 minutes'},
                {id: 45, title: '45 minutes'},
                {id: 60, title: '1 hour'}
            ]
        };

        $scope.getSpecialAccountsList = SelectService.getSpecialAccountsList;

        $scope.isPageMode = isPageMode;
        $scope.isPhoneValid = isPhoneValid;
        $scope.popupAPIKEY = popupAPIKEY;
        $scope.onRegisterSave = onRegisterSave;

        $scope.multilangInvitationTextPrinting = MultilanguageHelper();
        $scope.multilangInvitationText = MultilanguageHelper();
        $scope.initLocaleStrings = initLocaleStrings;
        $scope.getPages = getTotalPaginatedPages;
        $scope.currentTab = 'general';
        $scope.loyalty_id = '';
        $scope.currentTerminalStatus = null;
        $scope.monitoringJournalList = [];
        $scope.monitoringParams = {
            page: 1,
            count: 20,
            date_from: moment().subtract(1, 'week').utc().toDate(),
            date_to: moment().endOf('day').utc().toDate(),
            time_from: moment().startOf('day').utc().toDate(),
            time_to: moment().endOf('day').utc().toDate(),
            order: 'desc',
            sort: 'processed'
        };
        $scope.posterSettings = {
            account: '',
            active: false,
            application_id: '',
            client_number: '',
            settings: {
                is_send_qrcode: false,
                is_send_all_transaction: false,
                is_show_precheck: false,
            },
            spot_id: 0,
            spot_tablet_id: 0
        }

        $scope.showPosterSettings = false;

        $scope.kioskSettings = {
            CAMERA_SCAN: 'CAMERA_SCAN_AUTO',
            PRINT_SIZE: 595,
            PAYMENT_SUPPORT: {
                PERSONAL_ACCOUNT: true,
                COMMERCIAL_ACCOUNT: true,
                PAYMENT_CASH: false,
                PAYMENT_MOBILE_APP: false
            },
            AUTHORIZATION_METHOD: {
                SCAN_CARD: true,
                SCAN_QR: true,
                AUTH_PHONE: true,
                OTHER_AUTH_CODE: false,
                AUTH_EMAIL: false,
                AUTH_EXTERNAL_ID: false
            },
            VEHICLE_SCAN: {
                MAIN_METHOD: 'SCAN_QR',
                SCAN_CARD: true,
                MAGNETIC_CARD_READER: false,
                SCAN_QR: true,
                INPUT: true
            },
            NOTIFICATIONS: {
                IS_SOUND_ENABLED: true
            },
            // Printer
            PRINTER_SETTINGS: {
                CONNECTION_TYPE: 'none',
                BLUETOOTH: null,
                USB: null,
                TCP: null
            },
            PAY_TERMINAL_TYPE: 'none'
        }

        $scope.paxSettings = {}
        $scope.ampSettings = {}

        $scope.camera_scan_options = [
            'CAMERA_SCAN_AUTO',
            'CAMERA_SCAN_BACK',
            'CAMERA_SCAN_FRONT',
        ];

        $scope.print_size_options = [
            595,
            219.21259842519686,
            302.3622047244095,
        ];

        $scope.vehicle_scan_options = [
            {value: 'SCAN_CARD', title: 'terminal#kiosk#vehicle_methods_card'},
            {value: 'SCAN_QR', title: 'terminal#kiosk#vehicle_methods_qr'},
            {value: 'INPUT', title: 'terminal#kiosk#vehicle_methods_input'},
        ];

        $scope.terminal_types_options = [
            {value: 'PAX', title: 'IS_ENABLED_PAX'},
            {value: 'AMP', title: 'IS_ENABLED_AMP'},
            {value: 'none', title: 'None'},
        ];

        $scope.notifications = {
            active: false,
            connection_lost_notification_emails: [],
            logged_out_notification_emails: [],
            notify_if_connection_lost_more_then: 0,
            notify_if_logged_out_more_then: 0
        }
        $scope.posterApplications = [];
        var block_registers_list = blockUI.instances.get('registers_list');
        var block_register_edit = blockUI.instances.get('register_edit');
        var block_monitoring_list = blockUI.instances.get('monitoring-list');

        $scope.removeTerminalScreensaverSource = function (index) {
            console.log('index', index);
            console.log('screensaver_settings', $scope.model.register.screensaver_settings);
            if (!$scope.model.register.screensaver_settings
                && !$scope.model.register.screensaver_settings.sources) {
                return;
            }

            if ($scope.model.register.screensaver_settings.sources.length === 1) {
                $scope.model.register.screensaver_settings = null;
                return;
            }

            $scope.model.register.screensaver_settings.sources.splice(index, 1);
        };


        $scope.addTerminalScreensaverSourceModal = function (screensaver, index) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/terminals/modals/screensaver.modal.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;
                    popup.screensaverTypes = angular.copy($scope.data.screensaverTypes);
                    popup.isEdit = !!screensaver;

                    popup.screensaver = screensaver ? angular.copy(screensaver) : {
                        order: $scope.model.register.screensaver_settings && $scope.model.register.screensaver_settings.sources ?
                            (($scope.model.register.screensaver_settings.sources || []).length + 1) : 1,
                        type: 'youtube',
                        url: '',
                        show_time: null
                    };

                    popup.addScreensaver = function (screensaverForm) {

                        if (screensaverForm) {

                            if (popup.screensaver.type === 'youtube') {
                                // validate string is youtube url
                                // youtube.com/watch?v=
                                // youtu.be
                                var youtubeIdRegex =
                                    /^(?:(?:https|http):\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be).*?(?:\/|v\/|u\/|embed\/|shorts\/|watch\?v=|(?<username>user\/))(?<id>[\w\-]{11})(?:\?|&|$)/;
                                var youtubeId = popup.screensaver.url.match(youtubeIdRegex);
                                console.log(youtubeId);
                                if (!popup.screensaver.url || !popup.screensaver.url.length || !youtubeId || !youtubeId[2]) {
                                    // TODO validate youtube url
                                    screensaverForm.screensaver_url.$invalid = true;
                                    screensaverForm.screensaver_url.$dirty = true;
                                    return;
                                }
                            }

                            if (screensaverForm.$invalid) {
                                return;
                            }

                            if (screensaverForm.$invalid) {
                                return;
                            }

                        }


                        if (!$scope.model.register.screensaver_settings) {
                            $scope.model.register.screensaver_settings = {
                                sources: []
                            }
                        } else if (!$scope.model.register.screensaver_settings.sources) {
                            $scope.model.register.screensaver_settings.sources = [];
                        }

                        $scope.model.register.screensaver_settings.sources[index || 0] = popup.screensaver;
                        //  $scope.model.register.screensaver_settings.sources.push(popup.screensaver);
                        $uibModalInstance.close();
                    };

                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                        block_register_edit.stop();
                    };

                }
            });


        };


        $scope.monitoring_table_cols = [
            {
                visible: true,
                data: [
                    {
                        value: 'id',
                        text: 'Monitoring ID',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'remote_addr',
                        text: 'IP',
                        visible: true
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'processed',
                        text: 'Monitoring date',
                        visible: true,
                        sorting: 'processed'
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'status',
                        text: 'Monitoring status',
                        visible: true,
                        sorting: 'status'
                    }
                ]
            },
            {
                visible: true,
                data: [
                    {
                        value: 'staff_name',
                        text: 'Business staff name',
                        visible: true
                    },
                    {
                        value: 'staff_email',
                        text: 'Business staff email',
                        visible: true
                    },
                    {
                        value: 'staff_phone',
                        text: 'Business staff phone',
                        visible: true
                    }
                ]
            }
        ];
        $scope.platformSupportedLanguagesCodes = Object.keys(LANGS) || [];
        SettingsService.GetPlatformSupportedLanguages(function (success, response) {
            $scope.platformSupportedLanguagesCodes = response;
        });
        initController();

        function isPageMode(mode) {
            return mode == $scope._pageMode;
        }

        function isRouteMode(mode) {
            return $routeParams && $routeParams.hasOwnProperty('mode') && $routeParams.mode === mode;
        }

        function initPageMode() {
            $scope._pageMode = 'show';

            if (isRouteMode('edit')) {
                $scope._pageMode = ($routeParams.hasOwnProperty('terminal_id')) ? 'edit' : 'show';
            } else if (isRouteMode('create')) {
                $scope._pageMode = 'create';
            }

            if ($routeParams.terminal_id) {
                getRegisterFeedbackSettings($routeParams.terminal_id);
                if ($routeParams['tab'] === 'poster') {
                    TerminalService.GetPosterSettings($routeParams.terminal_id, function (success, response) {
                        if (success) {
                            if (response.active) {
                                $scope.posterSettings = response;
                                if (response.settings && (response.settings.is_send_qrcode || response.settings.is_send_all_transaction || response.settings.is_show_precheck)) {
                                    $scope.showPosterSettings = true;
                                }
                            }
                        }
                    });

                    TerminalService.GetPosterApplications($routeParams.terminal_id, function (success, response) {
                        if (success) {
                            $scope.posterApplications = response;
                        }
                    })
                }
                if ($routeParams['tab'] === 'kiosk') {
                    TerminalService.GetApplicationSettings($routeParams.terminal_id, function (success, response) {
                        if (success) {

                            $scope.kioskSettings = response;
                            console.log($scope.kioskSettings)
                            if(typeof $scope.kioskSettings.VEHICLE_SCAN !== "object" ) {
                                $scope.kioskSettings.VEHICLE_SCAN = {
                                    MAIN_METHOD: 'SCAN_QR',
                                    SCAN_CARD: true,
                                    MAGNETIC_CARD_READER: false,
                                    SCAN_QR: true,
                                    INPUT: true
                                }
                            }
                            if ($scope.kioskSettings.PAY_TERMINAL_TYPE === 'PAX') {
                                TerminalService.GetExternalDevicesPaxSettings($routeParams.terminal_id, function (successPax, responsePax) {
                                    if (successPax) {
                                        $scope.paxSettings = responsePax;
                                    }
                                })
                            }

                            if ($scope.kioskSettings.PAY_TERMINAL_TYPE === 'AMP') {
                                TerminalService.GetExternalDevicesAmpSettings($routeParams.terminal_id, function (successAmp, responseAmp) {
                                    if (successAmp) {
                                        $scope.ampSettings = responseAmp;
                                    }
                                })
                            }
                        }
                    })
                }
                if ($routeParams['tab'] === 'notifications') {
                    TerminalService.GetNotificationsSettings($routeParams.terminal_id, function (success, response) {
                        if (success) {
                            if (response.active) {
                                $scope.notifications = response
                            }
                        }
                    });
                }
            }

            if ($routeParams['tab'] && $routeParams['tab'] !== 'general') {
                $scope.currentTab = $routeParams['tab'];
            }

            switch ($scope._pageMode) {
                case 'show':
                    _doShow();
                    break;
                case 'create':
                    _doCreate();
                    break;
                case 'edit':
                    _doEdit();
                    break;
            }

        }

        function initLangsList() {
            $scope.data.langsList = [];
            for (var i in LANGS)
                $scope.data.langsList.push({id: i, title: LANGS[i]});

            $scope.data.langsList.push({id: 'az', title: 'Azərbaycan'});
        }

        function initController() {
            $scope.multilangInvitationTextPrinting.initLangs(LANGS, $rootScope.LANG);
            $scope.multilangInvitationText.initLangs(LANGS, $rootScope.LANG);

            SelectService.getLPRList(function (list) {
                $scope.data.filtersList = list;
            })

            initLangsList();
            initPageMode();

        }

        function _doShow() {
            getRegisters();
        }

        /**
         * Init terminal feedbacks settings
         */
        function initLocaleStrings(terminalFeedbackSettings) {
            $scope.multilangInvitationTextPrinting.initStrings(terminalFeedbackSettings, ['print_feedback_on_check_message_text']);
            $scope.multilangInvitationText.initStrings(terminalFeedbackSettings, ['transaction_feedback_message_text']);
        }

        /**
         * Event receive when change editing language
         */
        $scope.onChangeMultilangInvitationTextPrinting = function (new_lang) {
            $scope.multilangInvitationTextPrinting.selected(new_lang);
        };

        $scope.onChangeMultilangInvitationText = function (new_lang) {
            $scope.multilangInvitationText.selected(new_lang);
        };

        function getPriceGroups(loyaltyID) {
            $scope.data.priceGroups = [];
            if (loyaltyID) {
                PriceGroupsService.GetPriceGroups(loyaltyID, {}, function (success, response) {
                    if (success) {
                        $scope.data.priceGroups = response;
                        if ($scope.model.register.price_group_id) {
                            var priceGroup = response.find(function (priceGroup) {
                                return priceGroup.id === $scope.model.register.price_group_id;
                            });
                            if (!priceGroup) {
                                $scope.model.register.price_group_id = null;
                            }
                        }
                    }
                });
            }

        }

        function getRegisters() {
            block_registers_list.start();
            TerminalService.All(function (success, response) {
                if (success) {
                    $scope.data.registersList = $rootScope.TERMINALS;
                }
                block_registers_list.stop();
            });
        }

        function getFeedbackSources(loyaltyId) {
            var filteredPos;
            var loyaltyIdToSearch = loyaltyId;
            if (loyaltyId === '0' || loyaltyId === 0) {
                if (!$scope.data.posListToShow) {
                    return;
                }

                filteredPos = $scope.data.posListToShow.filter(function (item) {
                    return item.id === $scope.model.register.pos_id;
                });

                if (filteredPos && filteredPos.length) {
                    loyaltyIdToSearch = filteredPos[0].loyalty_id;
                } else {
                    return;
                }
            }

            if (!loyaltyIdToSearch) {
                return;
            }

            FeedbackService.getFeedbackSources(loyaltyIdToSearch, {
                page: 1,
                count: 20,
                only_active: false
            }, function (success, response) {
                if (success) {
                    $scope.data.feedbackSourcesList = response.data;
                    if ($scope.data.feedbackSourcesList && $scope.data.feedbackSourcesList.length && isPageMode('create')) {
                        $scope.model.registerFeedback.active = 0;
                        if (!$scope.$$phase) {
                            $scope.$digest();
                        }
                    }
                }
            });
        }

        function getRegisterFeedbackSettings(register_id) {
            FeedbackService.getFeedbackTerminalSettings(register_id, function (success, response) {
                if (success) {
                    $scope.model.registerFeedback = response;
                    if (response.print_feedback_on_check !== "none") {
                        $scope.model.possibilityPrintFeedbackOnCheck = true;
                    }
                    $scope.initLocaleStrings($scope.model.registerFeedback);
                }
            });
        }

        function saveRegisterFeedbackSettings(register_id) {
            FeedbackService.changeFeedbackTerminalSettings(register_id, $scope.model.registerFeedback, function (success, response) {
                if (success) {
                }
            });
        }

        function getAdditionalCosts(terminal_id) {
            $scope.data.additionalCosts = [];
            TerminalService.GetAdditionalCosts(terminal_id, function (success, response) {
                if (success) {
                    $scope.data.additionalCosts = response;
                    block_register_edit.stop();
                }
            });
        }

        $scope.onCountChange = function (count) {
            $scope.monitoringParams.page = 1;
            $scope.monitoringParams.count = count;
            $scope.getMonitoringJournal();
        };

        $scope.getTableHeaderClass = function (row) {
            return {
                'sorting': !!row.sorting,
                'sorting_asc': !!row.sorting && $scope.monitoringParams.sort === row.sorting && $scope.monitoringParams.order === 'asc',
                'sorting_desc': !!row.sorting && $scope.monitoringParams.sort === row.sorting && $scope.monitoringParams.order === 'desc'
            };
        };
        $scope.onSortOrderChange = function (row) {
            if (!row.sorting) {
                return;
            }
            if ($scope.monitoringParams.sort === row.sorting)
                $scope.monitoringParams.order = $scope.monitoringParams.order === 'asc' ? 'desc' : 'asc';
            else
                $scope.monitoringParams.order = 'asc';

            $scope.monitoringParams.sort = row.sorting;
            $scope.getMonitoringJournal();
        };

        $scope.pageChange = function () {
            $scope.getMonitoringJournal();
        };

        $scope.getMonitoringJournal = function () {
            var params = angular.copy($scope.monitoringParams);

            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get('hour'),
                minute: moment(params.time_from).get('minute'),
                second: moment(params.time_from).get('second')
            }).utc();
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get('hour'),
                minute: moment(params.time_to).get('minute'),
                second: moment(params.time_to).get('second')
            }).utc();
            delete params.time_to;
            params = dateFieldsFormat(params, null, 'YYYY-MM-DD[T]HH:mm:ss[Z]', false);
            block_monitoring_list.start();
            TerminalService.GetMonitoringJournal($routeParams.terminal_id, params, function (success, response) {
                if (success) {
                    $scope.data.summary = response.summary;
                    $scope.monitoringJournalList = response.data;
                }
                block_monitoring_list.stop();
            });
        };

        $scope.deleteAdditionalCost = function (additionalCost) {
            block_register_edit.start();
            var additionalCosts = $scope.data.additionalCosts.filter(function (item) {
                return item.additional_cost_id !== additionalCost.additional_cost_id;
            });
            TerminalService.UpdateAdditionalCosts($routeParams.terminal_id, additionalCosts, function (success, response) {
                if (success) {
                    getAdditionalCosts($routeParams.terminal_id);
                }
            });
        };

        $scope.onChangeTab = function (tab) {
            if ($scope.currentTab === tab) {
                return;
            }

            if ($scope.currentTab == 'general' && tab != 'general' && isPageMode('create')) {
                var form = angular.element('#platform-register-form').scope().form;
                $uibModal.open({
                    animation: true,
                    keyboard: true,
                    size: 'sm',
                    templateUrl: 'app/templates/modal.confirmation.html',
                    controllerAs: 'popup',
                    controller: function ($uibModalInstance) {
                        var popup = this;
                        popup.type = 'terminal';

                        popup.onSaveClick = function (exit) {
                            if (form.$valid && form.$dirty) {
                                $scope.onRegisterSave(form, false);
                                $scope.currentTab = tab;
                                $location.url($location.$$path + '?tab=' + tab);
                                $scope.onChangeTab(tab);
                            } else {
                                form.$dirty = true;
                                form.password.$dirty = true;
                            }
                            $uibModalInstance.close();
                        };

                        popup.onCancelClick = function (exit) {
                            if (isPageMode('create'))
                                $scope.currentTab = 'general';
                            else {
                                $scope.currentTab = tab;
                                $location.url($location.$$path + '?tab=' + tab);
                                $scope.onChangeTab(tab);
                            }
                            $uibModalInstance.close();
                        };
                    }
                });
            } else {
                $scope.currentTab = tab;
                $location.url($location.$$path + '?tab=' + tab);
                if ($scope.currentTab === 'staff') {
                    block_register_edit.start();
                    refreshStaff(function () {
                        block_register_edit.stop();
                    });
                    return;
                }
                if ($scope.currentTab === 'additionalCostsGoods') {
                    $scope.pageChangeAdditionalCostsItems();
                    getGoodsCategoriesList();
                    return;
                }
                if ($scope.currentTab === 'monitoringJournal') {
                    $scope.getMonitoringJournal();
                    return;
                }
                if ($scope.currentTab === 'poster') {
                    TerminalService.GetPosterSettings($routeParams.terminal_id, function (success, response) {
                        if (success) {
                            if (response.active) {
                                $scope.posterSettings = response;
                                if (response.settings && (response.settings.is_send_qrcode || response.settings.is_send_all_transaction || response.settings.is_show_precheck)) {
                                    $scope.showPosterSettings = true;
                                }
                            }
                        }
                    });

                    TerminalService.GetPosterApplications($routeParams.terminal_id, function (success, response) {
                        if (success) {
                            $scope.posterApplications = response;
                        }
                    })

                }

                if ($scope.currentTab === 'kiosk') {
                    TerminalService.GetApplicationSettings($routeParams.terminal_id, function (success, response) {
                        if (success) {
                            $scope.kioskSettings = response;
                            if ($scope.kioskSettings.PAY_TERMINAL_TYPE === 'PAX') {
                                TerminalService.GetExternalDevicesPaxSettings($routeParams.terminal_id, function (successPax, responsePax) {
                                    if (successPax) {
                                        $scope.paxSettings = responsePax;
                                    }
                                })
                            }

                            if ($scope.kioskSettings.PAY_TERMINAL_TYPE === 'AMP') {
                                TerminalService.GetExternalDevicesAmpSettings($routeParams.terminal_id, function (successAmp, responseAmp) {
                                    if (successAmp) {
                                        $scope.ampSettings = responseAmp;
                                    }
                                })
                            }
                        }
                    })
                }

                if ($scope.currentTab === 'notifications') {
                    TerminalService.GetNotificationsSettings($routeParams.terminal_id, function (success, response) {
                        if (success) {
                            if (response.active) {
                                $scope.notifications = response
                            }
                        }
                    });
                }
            }
        };

        $scope.onSavePosterSettings = function (form, closeOnSave) {
            if (isFormValid(form)) {
                block_register_edit.start();
                var post_data = angular.copy($scope.posterSettings);
                if (!$scope.posterSettings.active) {
                    post_data = {
                        active: false
                    }
                }

                TerminalService.UpdatePosterSettings($routeParams.terminal_id, post_data, function (success, response) {
                    if (success) {
                        NotifyService.Success('', false);
                        if (closeOnSave) {
                            $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
                        }
                    } else {
                        $scope.messages.error = response.message;
                        NotifyService.Error(response.message, false);
                    }
                    block_register_edit.stop();
                })
            }
        }


        $scope.onSaveKioskSettings = function (form, closeOnSave) {
            if (isFormValid(form)) {
                block_register_edit.start();
                var post_data = angular.copy($scope.kioskSettings);

                TerminalService.UpdateApplicationSettings($routeParams.terminal_id, post_data, function (success, response) {
                    if (success) {
                        if (!$scope.kioskSettings.PAY_TERMINAL_TYPE || $scope.kioskSettings.PAY_TERMINAL_TYPE === 'none') {
                            NotifyService.Success('', false);
                            if (closeOnSave) {
                                $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
                            }
                            block_register_edit.stop();
                            return;
                        }

                        if ($scope.kioskSettings.PAY_TERMINAL_TYPE === 'PAX') {
                            var pax_post_data = angular.copy($scope.paxSettings);
                            TerminalService.UpdateExternalDevicesPaxSettings($routeParams.terminal_id, pax_post_data, function (pax_success, pax_response) {
                                if (pax_success) {
                                    NotifyService.Success('', false);
                                    if (closeOnSave) {
                                        $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
                                    }
                                    block_register_edit.stop();
                                } else {
                                    $scope.messages.error = response.message;
                                    block_register_edit.stop();
                                }
                            })
                        }

                        if ($scope.kioskSettings.PAY_TERMINAL_TYPE === 'AMP') {
                            var amp_post_data = angular.copy($scope.ampSettings);
                            TerminalService.UpdateExternalDevicesAmpSettings($routeParams.terminal_id, amp_post_data, function (amp_success, amp_response) {
                                if (amp_success) {
                                    NotifyService.Success('', false);
                                    if (closeOnSave) {
                                        $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
                                    }
                                    block_register_edit.stop();
                                } else {
                                    $scope.messages.error = response.message;
                                    block_register_edit.stop();
                                }
                            })
                        }
                    } else {
                        $scope.messages.error = response.message;
                        block_register_edit.stop();
                    }
                })
            }
        }

        $scope.checkScanMethod = function (item, model) {
            if (!$scope.kioskSettings.VEHICLE_SCAN[item]) {
                $scope.kioskSettings.VEHICLE_SCAN[item] = true;
            }
        }

        $scope.checkPaymentMethod = function (item, model) {
            if (model === 'PAX') {
                TerminalService.GetExternalDevicesPaxSettings($routeParams.terminal_id, function (successPax, responsePax) {
                    if (successPax) {
                        $scope.paxSettings = responsePax;
                    }
                })
            }

            if (model === 'AMP') {
                TerminalService.GetExternalDevicesAmpSettings($routeParams.terminal_id, function (successAmp, responseAmp) {
                    if (successAmp) {
                        $scope.ampSettings = responseAmp;
                    }
                })
            }
        }

        $scope.onSaveNotificationSettings = function (form, closeOnSave) {
            if (isFormValid(form)) {
                block_register_edit.start();
                var post_data = angular.copy($scope.notifications);
                if (!$scope.notifications.active) {
                    post_data = {
                        active: false
                    }
                }

                TerminalService.UpdateNotificationsSettings($routeParams.terminal_id, post_data, function (success, response) {
                    if (success) {
                        NotifyService.Success('', false);
                        if (closeOnSave) {
                            $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
                        }
                    } else {
                        $scope.messages.error = response.message;
                    }
                    block_register_edit.stop();
                })
            }
        }

        $scope.openModalAddAdditionalCost = function (additionalCost) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/terminals/modals/additional-cost-add.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {

                    var popup = this;

                    popup.loyalty_id = $scope.loyalty_id;

                    popup.loading = true;
                    popup.isEdit = !!additionalCost;
                    popup.loyalty_additional_costs = [];
                    popup.default_additional_cost = undefined;

                    if (additionalCost) {
                        popup.additionalCost = angular.copy(additionalCost);
                        popup.additionalCost.default_value = parseFloat(
                            popup.additionalCost.default_value.toFixed(popup.additionalCost.additional_cost_decimal_digits));
                    } else {
                        popup.additionalCost = {
                            additional_cost_id: '',
                            additional_cost_title: '',
                            additional_cost_type: '',
                            default_value: '',
                            additional_cost_decimal_digits: 2,
                            use_base_cost_value: 1
                        };
                    }
                    popup.additional_cost_id = popup.additionalCost.additional_cost_id;

                    LoyaltyService.GetAdditionalCosts($scope.loyalty_id, function (success, response) {
                        if (success) {
                            popup.loyalty_additional_costs = response.filter(
                                function (id) {
                                    return !$scope.data.additionalCosts.some(function (additional_cost_id) {
                                        return additional_cost_id === id;
                                    });
                                });
                            popup.default_additional_cost = response.find(function (item) {
                                return item.id === popup.additional_cost_id;
                            });

                            popup.loading = false;
                        }
                    });

                    popup.checkUseBaseCostValue = function (additionalCost) {
                        if (additionalCost.use_base_cost_value) {
                            popup.additionalCost.default_value = popup.default_additional_cost.default_value;
                        }
                    };

                    popup.onSelectAdditionalCost = function () {
                        var additional_cost = popup.loyalty_additional_costs.find(function (item) {
                            return item.id === popup.additional_cost_id;
                        });
                        console.log('additional_cost', additional_cost);
                        popup.default_additional_cost = additional_cost;
                        popup.additionalCost = {
                            additional_cost_id: additional_cost.id,
                            additional_cost_title: additional_cost.title,
                            additional_cost_type: additional_cost.type,
                            default_value: parseFloat(additional_cost.default_value.toFixed(additional_cost.decimal_digits)),
                            additional_cost_decimal_digits: additional_cost.decimal_digits,
                            use_base_cost_value: popup.additionalCost.use_base_cost_value !== undefined ? popup.additionalCost.use_base_cost_value : 1
                        };
                    };

                    popup.changeValue = function () {
                        if (popup.additionalCost.default_value) {
                            popup.additionalCost.default_value = parseFloat(
                                popup.additionalCost.default_value.toFixed(popup.additionalCost.additional_cost_decimal_digits));
                        }
                    };

                    popup.addAdditionalCost = function () {
                        block_register_edit.start();
                        popup.additionalCost.use_base_cost_value = +popup.additionalCost.use_base_cost_value;
                        var data = [
                            ...$scope.data.additionalCosts,
                            popup.additionalCost
                        ]
                        TerminalService.UpdateAdditionalCosts($routeParams.terminal_id, data,
                            function (success, response) {
                                if (success) {
                                    $uibModalInstance.close();
                                    getAdditionalCosts($routeParams.terminal_id);

                                }
                            });
                    };

                    popup.EditAdditionalCost = function () {
                        block_register_edit.start();
                        var additionalCosts = angular.copy($scope.data.additionalCosts);

                        var additionalCostsIndex = additionalCosts.findIndex(function (item) {
                            return item.additional_cost_id === popup.additionalCost.additional_cost_id;
                        });

                        console.log('additionalCostsIndex', additionalCostsIndex);

                        if (additionalCostsIndex !== -1 && additionalCosts[additionalCostsIndex]) {
                            additionalCosts[additionalCostsIndex].default_value = popup.additionalCost.default_value;
                            additionalCosts[additionalCostsIndex].use_base_cost_value = parseInt(popup.additionalCost.use_base_cost_value);
                        }
                        console.log('additionalCosts', additionalCosts);
                        TerminalService.UpdateAdditionalCosts($routeParams.terminal_id, additionalCosts, function (success, response) {
                            if (success) {
                                $uibModalInstance.close();
                                getAdditionalCosts($routeParams.terminal_id);

                            }
                        });
                    };

                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                        block_register_edit.stop();
                    };

                }
            });
        };

        $scope.openModalEditValueItem = function (additionalCostsItem) {
            $uibModal.open({
                animation: true,
                keyboard: true,
                backdrop: 'static',
                templateUrl: 'app/pages/terminals/modals/additional-cost-edit-item-value.html',
                controllerAs: 'popup',
                windowTopClass: 'modal-center',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.valueOptions = $scope.valueOptions;

                    popup.additionalCostsItem = angular.copy(additionalCostsItem);

                    popup.additionalCostsItem.additional_costs.forEach(function (cost) {
                        if (cost.value !== undefined) {
                            if (cost.value === null) {
                                cost.fieldMode = 'default';
                                cost.value = cost.default_value;
                            } else if (cost.value === 0) {
                                cost.fieldMode = 'not-use';
                            } else {
                                cost.fieldMode = 'manual';
                            }
                        } else {
                            cost.fieldMode = 'default';
                            cost.value = cost.default_value;
                        }
                    });

                    popup.taxRateFieldModeChange = function (cost) {
                        switch (cost.fieldMode) {
                            case 'manual':
                            case 'default':
                                cost.value = cost.default_value;
                                break;
                            case 'not-use':
                                cost.value = 0;
                                break;
                            default:
                                break;
                        }
                    };

                    popup.changeValue = function (cost) {
                        if (cost.value) {
                            cost.value = parseFloat(cost.value.toFixed(cost.additional_cost_decimal_digits));
                        }
                    };

                    popup.EditAdditionalCost = function () {
                        updateItemValue();
                    };

                    popup.ResetToDefaultValue = function () {
                        popup.additionalCostsItem.additional_costs.forEach(function (item) {
                            return item.value = null;
                        });
                        updateItemValue();
                    };

                    popup.closeModal = function (exit) {
                        $uibModalInstance.close();
                        block_register_edit.stop();
                    };

                    function updateItemValue() {
                        block_register_edit.start();

                        popup.additionalCostsItem.additional_costs.forEach(function (cost) {
                            switch (cost.fieldMode) {
                                case 'default':
                                    cost.value = null;
                                    break;
                                case 'not-use':
                                    cost.value = 0;
                                    break;
                                case 'manual':
                                    if (cost.value === null) {
                                        cost.value = 0;
                                    }
                                    break;
                                default:
                                    break;
                            }

                        });

                        TerminalService.UpdateAdditionalCostsItem($routeParams.terminal_id, popup.additionalCostsItem.item_id,
                            popup.additionalCostsItem, function (success, response) {
                                if (success) {
                                    $uibModalInstance.close();
                                    refreshAdditionalCostsItems(function () {
                                        block_register_edit.stop();
                                    });
                                }
                            });
                    }

                }
            });
        };

        $scope.registerTypeTitle = function (t) {
            var register_type = $filter('filter')($scope.data.registerTypes, {id: t.type}, true)[0];
            if (register_type) {
                return register_type.title;
            } else {
                return '';
            }
        };

        $scope.itemFiltered = function (t) {
            if ($scope.data.currentFilter) {
                if ($scope.data.currentFilter.id === '0')
                    return true;

                if ($scope.data.currentFilter.filter_list_type === 'loyalty' && $scope.data.currentFilter.id == t.loyalty_id)
                    return true;

                return $scope.data.currentFilter.filter_list_type === 'pos' && $scope.data.currentFilter.id == t.pos_id;
            } else {
                return true;
            }
        };

        $scope.isLoyaltyActive = function (pos_id) {
            var l = null;
            var p = null;
            if ($rootScope.POS) {
                p = itemByIndex($rootScope.POS, pos_id);
                if ($rootScope.LOYALTIES && p) {
                    l = itemByIndex($rootScope.LOYALTIES, p.loyalty_id);
                    return l && l.active;
                }
            }

            return true;
        };

        $scope.isPOSActive = function (pos_id) {
            var p = null;
            if ($rootScope.POS) {
                p = itemByIndex($rootScope.POS, pos_id);

                return p && p.active;
            }

            return true;
        };

        $scope.onCopyPasswordClick = function (terminal_id) {
            itemByIndex($scope.data.registersList, terminal_id).tooltip_opened = true;
            $timeout(function () {
                itemByIndex($scope.data.registersList, terminal_id).tooltip_opened = false;
            }, 3000);
        };

        function popupAPIKEY(terminal) {
            $scope.modals.ApiKey = $uibModal.open({
                animation: true,
                keyboard: true,
                templateUrl: 'app/templates/modal.register.api_key.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;
                    popup.terminal = terminal;

                    popup.onAPIKEYCopy = function () {
                        popup.APIKEYCopied = true;
                        $timeout(function () {
                            popup.APIKEYCopied = false;
                        }, 3000);
                    };

                    popup.onAPIKEYUpdate = function (terminal_id) {
                        popup.message = null;
                        TerminalService.APIKey(terminal_id, function (success, response) {
                            if(!success) {
                                popup.message = response.message;
                                return;
                            }
                            popup.terminal.api_key = response.api_key;
                        });
                    };

                    popup.goToTariff = function () {
                        $scope.modals.ApiKey.close();
                        $location.path('/tariff');
                    };

                    popup.onCancelClick = function (exit) {
                        $scope.modals.ApiKey.close();
                    };
                }
            });
        }

        function initNewRegister() {
            $scope.model.new_register = {
                type: isRoadTankerDriverMode ? 'road-tanker-driver' : 'register',
                display_customer_reward_amount: 0,
                display_type: 'customer-identity',
                display_account_type: 'regular-bonuses',
                display_promotional_bonuses_expire_type: 'date',
                display_promotional_bonuses_expire_value: 1,
                display_promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate(),
                display_refill_timeout: 24,
                ibeacon_account_type: 'regular-bonuses',
                ibeacon_customer_reward_amount: 1,
                ibeacon_promotional_bonuses_expire_value: 1,
                ibeacon_promotional_bonuses_expire_type: 'date',
                ibeacon_refill_timeout: 24,
                ibeacon_promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate(),
                mobile_app_payment_amount_free: 0,
                staff_sign_in_required: 0
            };

            $scope.model.register = angular.copy($scope.model.new_register);
        }

        function _doCreate() {
            initNewRegister();
            $scope.initLocaleStrings($scope.model.registerFeedback);
            $scope.model.use_price_group = false;
            if ($rootScope.TERMINALS)
                $scope.model.register.title = $scope.model.register.login
                    = $rootScope.TERMINALS.length + 1 + '@' + $rootScope.ENV.business.status.business_code;
            else
                TerminalService.All(function (success, data) {
                    if (success)
                        $scope.model.register.title = $scope.model.register.login
                            = $rootScope.TERMINALS.length + 1 + '@' + $rootScope.ENV.business.status.business_code;
                });

            function handlePOSResult(pos_list) {
                var c;

                if ($routeParams['pid']) {
                    $scope.model.register.pos_id = $routeParams['pid'];
                } else if ($scope.data.currentFilter && $scope.data.currentFilter.filter_list_type === 'pos') {
                    $scope.model.register.pos_id = $scope.data.currentFilter.id;
                } else {
                    var pos = getFirstActive(pos_list);
                    if (!!pos) {
                        $scope.model.register.pos_id = pos.id;
                    }
                }

                c = itemByIndex(pos_list, $scope.model.register.pos_id).country;

                $scope.model.register.customer_messages_language = setDefaultLanguage(c);

                $rootScope.getCountries(function (success, data) {
                    if (success) {
                        $scope.model.register.currency = itemByIndex($rootScope.ENV.countries[$rootScope.LANG], c).currency;
                        initCurrencyList();
                    }
                });
            }

            var loyalty_id;

            if ($scope.data.currentFilter && $scope.data.currentFilter.filter_list_type === 'loyalty') {
                loyalty_id = $scope.data.currentFilter.id;
            } else if ($scope.data.currentFilter && $scope.data.currentFilter.filter_list_type === 'pos') {
                loyalty_id = $scope.data.currentFilter.loyalty_id;
            }

            console.log('Current filter =>', $scope.data.currentFilter);
            if (loyalty_id && $scope.data.currentFilter) {
                POSService.forLoyalty(loyalty_id, function (success, data) {
                    if (success && data) {
                        $scope.data.posListToShow = data;
                        handlePOSResult(data);
                    }
                });
            } else {
                POSService.All({}, function (success, data) {
                    if (success && data) {
                        $scope.data.posListToShow = data;
                        handlePOSResult(data);
                    }
                });
            }
        }

        function handleBatchData() {
            var cf = {
                display_type: 'customer-identity',
                display_account_type: 'regular-bonuses',
                display_customer_reward_amount: 0,
                display_promotional_bonuses_expire_type: 'date',
                display_promotional_bonuses_expire_value: 1,
                display_promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate(),
                display_refill_timeout: 24,
                ibeacon_account_type: 'regular-bonuses',
                ibeacon_customer_reward_amount: 1,
                ibeacon_promotional_bonuses_expire_value: 1,
                ibeacon_promotional_bonuses_expire_type: 'date',
                ibeacon_refill_timeout: 24,
                ibeacon_promotional_bonuses_expire_date: moment().add(1, 'month').utc().toDate()
            };

            for (var i in cf)
                //if (!$scope.model.register[i])
                if ($scope.model.register[i] === 'undefined' || $scope.model.register[i] === null || $scope.model.register[i] === NaN)
                    $scope.model.register[i] = cf[i];
        }

        function _doEdit() {
            block_register_edit.start();
            TerminalService.Get($routeParams.terminal_id, function (success, response) {
                if (success) {
                    $scope.model.register = response;
                    $scope.model.use_price_group = !!response.price_group_id;
                    $scope.loyalty_id = response.loyalty_id;
                    $scope.currentTerminalStatus = response.last_event_status ? response.last_event_status.status : null;
                    POSService.forLoyalty($scope.model.register && $scope.model.register.loyalty_id, function (success, data) {
                        if (success && data) {
                            $scope.data.posListToShow = data;
                        } else {
                            $scope.data.posListToShow = $rootScope.POS;
                        }
                        getPriceGroups(response.loyalty_id || false);
                    });
                    getAdditionalCosts($routeParams.terminal_id);
                    $scope.data.currentPOS = itemByIndex($scope.data.posListToShow, $scope.model.register.pos_id);

                    if (!$scope.model.register.customer_messages_language)
                        $scope.model.register.customer_messages_language = setDefaultLanguage(
                            itemByIndex($scope.data.posListToShow, $scope.model.register.pos_id).country);

                    initCurrencyList();

                    handleBatchData();

                    switch ($scope.currentTab) {
                        case 'staff':
                            block_register_edit.start();
                            refreshStaff(function () {
                                block_register_edit.stop();
                            });

                            break;
                        case 'additionalCostsGoods':
                            block_register_edit.start();
                            getGoodsCategoriesList();
                            $scope.data.AdditionalCostsItems = [];

                            refreshAdditionalCostsItems(function () {
                                block_register_edit.stop();
                            });
                            break;
                        case 'monitoringJournal':
                            block_register_edit.start();
                            $scope.getMonitoringJournal();
                            block_register_edit.stop();
                            break;
                    }

                } else {
                    $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
                }
                block_register_edit.stop();
            });
        }

        function getGoodsCategoriesList() {
            SelectService.getGoodsCategoriesList($scope.loyalty_id, function (success, response) {
                $scope.data.categoriesList = angular.copy(response);
                $scope.data.categoriesList.unshift({
                    id: 'root',
                    active: 1,
                    title: $filter('translate')('Without category')
                });
                $scope.data.categoriesList.unshift({
                    id: 'all',
                    active: 1,
                    title: $filter('translate')('All category')
                });

            });
        }

        /**
         * получаем список товаров в наценках
         * @param callback
         */
        function refreshAdditionalCostsItems(callback) {
            $scope.data.AdditionalCostsItems = [];
            var paramsItems = angular.copy($scope.data.paramsAdditionalCostsItems);
            if (paramsItems.item_category_id && paramsItems.item_category_id === 'all') {
                delete paramsItems.item_category_id;
            }
            TerminalService.GetAdditionalCostsItems($routeParams.terminal_id, paramsItems, function (success, data) {
                if (success) {
                    $scope.data.AdditionalCostsItems = data;
                }
                if (callback) {
                    callback();
                }
            });
        }

        $scope.deleteStaffAccess = function (staff) {
            block_register_edit.start();
            TerminalService.DeleteAccessStaff($routeParams.terminal_id, [
                {
                    id: staff.id
                }
            ], function (success, data) {
                refreshStaff(function () {
                    block_register_edit.stop();
                });
            });

        };

        function refreshStaff(callback) {
            $scope.data.staff = [];
            TerminalService.GetStaff($routeParams.terminal_id, function (success, data) {
                if (success) {
                    $scope.data.staff = data;
                }
                if (callback) {
                    callback();
                }
            });
        }

        /**
         * смена сколько показывать на странице
         */
        $scope.onCountChangeAdditionalCostsItems = function (count) {
            block_register_edit.start();
            $scope.data.paramsAdditionalCostsItems.page = 1;
            $scope.data.paramsAdditionalCostsItems.count = count;
            refreshAdditionalCostsItems(function () {
                block_register_edit.stop();
            });
        };

        /**
         * смена страницы в постраничной навигации
         */
        $scope.pageChangeAdditionalCostsItems = function () {
            block_register_edit.start();
            refreshAdditionalCostsItems(function () {
                block_register_edit.stop();
            });
        };
        $scope.onChangeShowOnlyActive = function () {
            block_register_edit.start();
            refreshAdditionalCostsItems(function () {
                block_register_edit.stop();
            });
        };
        /**
         * слушаем изменение item_category_id категории
         */
        $scope.$watch('data.paramsAdditionalCostsItems.item_category_id', function (newValue, oldValue, scope) {
            if (newValue && newValue !== oldValue && $scope.currentTab === 'additionalCostsGoods') {
                block_register_edit.start();
                refreshAdditionalCostsItems(function () {
                    block_register_edit.stop();
                });
            }
        });

        function initCurrencyList() {
            var country,
                currency,
                cl = {};

            function handleResult(list) {
                var pos_id;

                if ($scope.model.register && $scope.model.register.pos_id)
                    pos_id = $scope.model.register.pos_id;
                else
                    pos_id = $rootScope.POS[0].id;

                country = itemByIndex(list, pos_id).country;

                $rootScope.getCountries(function (success, data) {
                    if (success) {
                        currency = itemByIndex($rootScope.COUNTRIES[$rootScope.LANG], country).currency;

                        cl[currency] = currency;
                        cl['EUR'] = 'EUR';
                        cl['USD'] = 'USD';

                        // var index;
                        // for (var i in cl)
                        //     if ($scope.model.register && $scope.model.register.currency === cl[i])
                        //         index = i;

                        // if ($scope.model.register && !$scope.model.register.currency)
                        //     $scope.model.register.currency = currency;

                        $scope.data.currencyList = [];
                        for (var i in cl)
                            $scope.data.currencyList.push({id: i, title: i});
                    }
                });

                block_register_edit.stop();
            }

            $rootScope.getCountries(function (success, data) {
                if (success) {
                    if ($rootScope.POS) {
                        handleResult($rootScope.POS);
                    } else {
                        POSService.All({}, function (success, data) {
                            if (success) {
                                handleResult($rootScope.POS);
                            }
                        });
                    }
                }
            });
        }

        function setDefaultLanguage(country) {
            var lang = $rootScope.LANG;
            if (country)
                if (country === 'UA')
                    return 'uk';
                else if (country === 'RU')
                    return 'ru';
                else if (country === 'PL')
                    return 'pl';
                else if (lang === 'ru')
                    return 'ru';
                else
                    return 'en';
            else
                return 'en';
        }

        $scope.onChangeUsePriceGroup = function () {
            if ($scope.model.use_price_group && !$scope.model.register.price_group_id) {
                var priceGroup = $scope.data.priceGroups.find(function (priceGroup) {
                    return priceGroup.currency === $scope.model.register.currency;
                });

                if (priceGroup) {
                    $scope.model.register.price_group_id = priceGroup.id;
                }
            }
            console.log('onChangeUsePriceGroup', $scope.model.use_price_group);
        };

        $scope.OnChangePossibilityPrintFeedbackOnCheck = function () {
            if (!$scope.model.possibilityPrintFeedbackOnCheck) {
                $scope.model.registerFeedback.print_feedback_on_check = "none";
            } else {
                $scope.model.registerFeedback.print_feedback_on_check = "qr-code";
            }
        };

        $scope.oniBeaconEnableChange = function () {
            if ($scope.model.register.ibeacon_active && !$scope.model.register.ibeacon_uuid) {
                TerminalService.iBeacon($scope.model.register.id, function (success, responce) {
                    $scope.model.register.ibeacon_uuid = responce.ibeacon_uuid;
                    $scope.model.register.ibeacon_minor = responce.ibeacon_minor;
                    $scope.model.register.ibeacon_major = responce.ibeacon_major;
                });
            }
        };

        function onRegisterSave(form, closeOnSave) {
            function handleResult(success, response) {
                if (success) {
                    saveRegisterFeedbackSettings(response.id);
                    updateItemInList($rootScope.TERMINALS, response);

                    if (closeOnSave)
                        $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
                } else {
                    $scope.messages.error = response.message;
                }
                if (isPageMode('create')) {
                    if (closeOnSave) {
                        $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
                    }

                    if (!closeOnSave) {
                        $location.path('/terminals/edit/' + response.id);
                    }
                }
                block_register_edit.stop();
            }

            if (isFormValid(form)) {
                block_register_edit.start();

                var post_data = angular.copy($scope.model.register);

                post_data = dateFieldsFormat(post_data, 'YYYY-MM-DD[T]HH:mm:ss[Z]', 'YYYY-MM-DD');
                post_data = cleanRequestData(post_data, ['screensaver_settings']);
                if (!$scope.model.use_price_group) {
                    post_data.price_group_id = null;
                }

                post_data.loyalty_id = itemByIndex($rootScope.POS, post_data.pos_id).loyalty_id;
                console.log('post_data', post_data);
                switch ($scope._pageMode) {
                    case 'create':
                        TerminalService.Create(post_data, handleResult);
                        break;
                    case 'edit':
                        TerminalService.Change(post_data.id, post_data, handleResult);
                        break;
                    default:

                }
            }

        }

        $scope.onCancelEdit = function () {
            $location.path(isRoadTankerDriverMode ? '/road-terminals' : '/terminals');
        };

        $scope.onTerminalToggleClick = function (terminal) {
            block_registers_list.start();
            var post_data = {
                id: terminal.id,
                active: 1 * !Boolean(terminal.active)
            };
            TerminalService.Change(terminal.id, post_data, function (success, data) {
                block_registers_list.stop();
            });
        };

        $scope.onShowQR = function (register) {
            $scope.modals.TerminalLink = $uibModal.open({
                animation: true,
                keyboard: true,
                size: 'md',
                templateUrl: 'app/templates/modal.register.link.html',
                controllerAs: 'popup',
                controller: function ($uibModalInstance) {
                    var popup = this;

                    popup.model = {
                        link: 'https://' + appConfig.platformParams.client_site[$rootScope.LANG] +
                            '/qr/register/{0}?auth_token={token}'.format(register.id)
                    };

                    popup.onPrint = function () {
                        var printContents = document.getElementById('printable-qr').innerHTML,
                            canvas_qr_dataurl = document.getElementsByTagName('canvas')[0].toDataURL(),
                            canvas_string = '<canvas class="qrcode" height="512" width="512"></canvas>',
                            popupWin = window.open('', '_blank',
                                'screenX=1,screenY=1,left=1,top=1,' + 'width=' + screen.availWidth + ',height=' + screen.availHeight);

                        printContents = printContents.replace(canvas_string, '<img src="' + canvas_qr_dataurl + '">');

                        popupWin.document.open();
                        popupWin.document.write('<html><head><base href="/"><title></title>' +
                            '<link href="assets/print/print_qr.min.css" rel="stylesheet"/></head>' +
                            '<body>' + printContents + '</body></html>');
                        popupWin.focus();
                        // setTimeout(function () {
                        //     popupWin.document.execCommand('print');
                        //     popupWin.print();
                        //     popupWin.document.close();
                        //     popupWin.close();
                        // }, 10);
                        var count = popupWin.document.querySelectorAll('img, link').length;

                        function printOnLoad() {
                            setTimeout(function () {
                                popupWin.focus();
                                popupWin.document.execCommand('print');
                                // popupWin.print();
                                popupWin.document.close();
                                popupWin.close();
                            }, 200);
                        }

                        if (count) {
                            popupWin.document.querySelectorAll('img, link').forEach(function (el) {
                                el.onload = function () {
                                    if (!--count) {
                                        printOnLoad();
                                    }
                                };
                            });
                        } else {
                            printOnLoad();
                        }
                    };

                    popup.onCopyLink = function () {
                        $scope.modals.TerminalLink.close();
                    };

                    popup.onCancelClick = function () {
                        $scope.modals.TerminalLink.close();
                    };
                }
            });
        };

        $scope.$watchCollection('[model.register.title, model.register.login, model.register.password]', function (newValues, oldValues) {
            $scope.messages.error = null;
        });

        $scope.$watch('model.register.pos_id', function (newValues, oldValues) {
            if ((isPageMode('edit') || isPageMode('create')) && newValues !== oldValues && newValues) {
                var pos = ($scope.data.posListToShow || []).find(function (pos) {
                    return pos.id === newValues;
                });
                getPriceGroups(pos && pos.loyalty_id || false);

            }
        });

        $scope.$watch('model.register.currency', function (newValues, oldValues) {
            if ((isPageMode('edit') || isPageMode('create')) && newValues !== oldValues && newValues) {

                var priceGroup = $scope.data.priceGroups.find(function (priceGroup) {
                    return priceGroup.currency === $scope.model.register.currency;
                });
                if (!priceGroup && $scope.data.priceGroups.length > 0) {
                    $scope.model.register.price_group_id = null;
                }
            }
        });

        $rootScope.$watch('LPR_LIST', function (newValue, oldValue) {
            // TODO loyalties List call

            if (newValue && newValue.length > 0) {
                $scope.data.filtersList = [];
                for (var i in $rootScope.LPR_LIST)
                    if ($rootScope.LPR_LIST[i].filter_list_type === 'loyalty' || $rootScope.LPR_LIST[i].filter_list_type === 'pos')
                        $scope.data.filtersList.push($rootScope.LPR_LIST[i]);

                if (isRoadTankerDriverMode) {
                    $scope.data.filtersList = $scope.data.filtersList.filter(function (item, index) {
                        if ($rootScope.TERMINALS.find(function (term) {
                            if (term.type === 'road-tanker-driver') {
                                if (item.filter_list_type === 'loyalty' && item.id === term.loyalty_id) {
                                    return true;
                                } else if (term.type === 'road-tanker-driver' && item.id === term.pos_id) {
                                    return true;
                                }
                            }
                        })) {
                            return item;
                        }

                    });

                }
                console.log('$scope.data.filtersList', $scope.data.filtersList);
                if ($scope._pageMode === 'show')
                    $scope.data.filtersList.unshift({
                        title: $filter('translate')('All loyalties'),
                        id: '0',
                        active: 1,
                        filter_list_type: 'all'
                    });

                if ($rootScope.ENV.filters.global_filter && $rootScope.ENV.filters.global_filter.loyalty_id !== '0') {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (filterItem) {
                        if ($rootScope.ENV.filters.global_filter.loyalty_id && !$rootScope.ENV.filters.global_filter.pos_id) {
                            if (filterItem.filter_list_type === 'loyalty' && !$rootScope.ENV.filters.global_filter.pos_id) {
                                if (filterItem.id === $rootScope.ENV.filters.global_filter.loyalty_id) {
                                    return true;
                                }
                            }
                        }
                        if ($rootScope.ENV.filters.global_filter.loyalty_id && $rootScope.ENV.filters.global_filter.pos_id) {
                            if (filterItem.filter_list_type === 'pos' || filterItem.filter_list_type === 'register') {
                                if (filterItem.loyalty_id === $rootScope.ENV.filters.global_filter.loyalty_id && filterItem.id === $rootScope.ENV.filters.global_filter.pos_id) {
                                    return true;
                                }
                            }
                        }
                    });
                } else {
                    var index;

                    switch ($scope._pageMode) {
                        case 'show':
                            for (var i in $scope.data.filtersList)
                                if ($scope.data.filtersList[i].id === '0')
                                    $scope.data.currentFilter = $scope.data.filtersList[i];
                            break;
                        case 'create':
                            //$scope.data.currentFilter = getFirstActive($scope.data.filtersList);
                            break;
                    }
                }
            }
        });

        $scope.$watch('data.currentFilter', function (newValue, oldValue) {

            if (newValue) {
                switch ($scope._pageMode) {
                    case 'show':
                        _doShow();

                        $rootScope.ENV.filters.registers_list = {
                            filter: newValue
                        };

                        if (newValue.filter_list_type === 'loyalty') {
                            $rootScope.ENV.filters.global_filter = {loyalty_id: newValue.id};
                        } else if (newValue.filter_list_type === 'pos' || newValue.filter_list_type === 'register') {
                            $rootScope.ENV.filters.global_filter = {
                                loyalty_id: newValue.loyalty_id,
                                pos_id: newValue.id
                            };
                        } else if (newValue.id === '0') {
                            $rootScope.ENV.filters.global_filter = {loyalty_id: '0'};
                        }

                        $rootScope.storeENV();
                        break;
                    case 'create':
                        _doCreate();
                        break;
                }
            }
        }, true);

        $rootScope.$watch('POS', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.posList = angular.copy($rootScope.POS);
                setTimeout(function () {
                    getFeedbackSources('0');
                }, 1000);
            }
        });

        $scope.$watch('model.register.pos_id', function (newValue, oldValue) {
            if (newValue && newValue !== oldValue) {
                initCurrencyList();
            }
            getFeedbackSources('0');
        });

        $rootScope.$watch('ACCOUNTS', function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                var l = $rootScope.ACCOUNTS;

                $scope.data.specialAccountsList = [];

                for (var i in l)
                    if (l[i].active === 1)
                        $scope.data.specialAccountsList.push(l[i]);

                if ($scope.model.register && $scope.data.specialAccountsList.length > 0) {
                    if (!$scope.model.register.display_special_account_id)
                        $scope.model.register.display_special_account_id = $scope.data.specialAccountsList[0].id;

                    if (!$scope.model.register.ibeacon_special_account_id)
                        $scope.model.register.ibeacon_special_account_id = $scope.data.specialAccountsList[0].id;
                }

            }
        });

    }
})();
